import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { PagedResult, IngestRunDto, QueryOptions } from '../lib/types';

export function useIngestRuns(options: QueryOptions) {
  const params = new URLSearchParams();
  if (options.page) params.set('page', String(options.page));
  if (options.pageSize) params.set('pageSize', String(options.pageSize));
  if (options.sortBy) params.set('sortBy', options.sortBy);
  if (options.sortDesc != null) params.set('sortDesc', String(options.sortDesc));

  const latestRun = useQuery({
    queryKey: ['admin', 'ingest-runs', 'latest'],
    queryFn: () =>
      apiClient
        .get<PagedResult<IngestRunDto>>('/api/admin/ingest/runs?page=1&pageSize=1')
        .then((r) => r.items[0] ?? null),
    refetchInterval: (query) => {
      const run = query.state.data;
      return run?.status === 'Running' ? 10_000 : undefined;
    },
  });

  const list = useQuery({
    queryKey: ['admin', 'ingest-runs', options],
    queryFn: () => apiClient.get<PagedResult<IngestRunDto>>(`/api/admin/ingest/runs?${params}`),
    refetchInterval: (query) => {
      const data = query.state.data;
      const running = data?.items.some((r) => r.status === 'Running');
      return running ? 10_000 : undefined;
    },
  });

  return { latestRun, list };
}

export function useRunIngest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiClient.post<IngestRunDto>('/api/admin/ingest/run', {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'ingest-runs'] }),
  });
}
